import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import Header from '../components/Header';
import BottomNav from '../components/BottomNav';
import { getDeputyTitleFromRouteId } from '../utils/deputy';
import { useParams } from 'react-router-dom';
import { getOrgStructureImage, getBackgroundImage } from '../utils/organization';

export default function OrganizationPage() {
  const { id } = useParams();
  const { t, i18n } = useTranslation();
  const [dbImage, setDbImage] = useState<string | null>(null);

  useEffect(() => {
    if (!id) return;
    fetch(`/api/organization?deputy_id=${id}`)
      .then((res) => res.json())
      .then((data) => {
        if (data && data.length > 0 && data[0].image_url) {
          setDbImage(data[0].image_url);
        }
      })
      .catch(() => {});
  }, [id]);

  const lang = i18n.language as 'id' | 'en';
  const displayImage = dbImage || getOrgStructureImage(id)?.[lang];
  const bgImage = getBackgroundImage(id);
  const deputyTitle = getDeputyTitleFromRouteId(id, t);

  return (
    <div
      className="min-h-screen w-full bg-[#002D4B] flex flex-col justify-between text-white bg-cover bg-no-repeat relative overflow-x-hidden overflow-y-auto"
      style={{
        backgroundImage: `linear-gradient(180deg, rgba(0, 30, 49, 0.88) 0%, rgba(0, 45, 75, 0.95) 100%), url(${bgImage})`,
      }}
    >
      <div className="w-full max-w-[1500px] mx-auto px-4 md:px-[60px] min-h-screen flex flex-col justify-between py-[20px] relative z-10">
        <Header />

        {/* Main Content Area */}
        <div className="flex-1 my-auto w-full flex flex-col items-center justify-center py-[10px]">
          {/* Section Title & Badge Header */}
          <div className="text-center mb-[12px] space-y-[4px]">
            <span className="text-xs uppercase font-extrabold tracking-widest text-[#00AFDD] bg-[#001E31]/90 px-[16px] py-[6px] rounded-full border border-[#00AFDD]/40 backdrop-blur-md shadow-md">
              {deputyTitle}
            </span>
            <h1 className="text-xl md:text-2xl font-extrabold uppercase tracking-wide text-white drop-shadow-md mt-1">
              {t('structure')} ORGANISASI
            </h1>
            <div className="w-[80px] h-[3px] bg-[#00AFDD] rounded-full mx-auto mt-1"></div>
          </div>

          {/* Org Chart Image Container */}
          <div className="w-full min-h-[400px] max-h-[calc(100vh-230px)] flex justify-center items-center p-[16px] bg-slate-900/60 border border-white/15 rounded-3xl backdrop-blur-md shadow-2xl overflow-auto custom-scrollbar relative">
            {displayImage ? (
              <img
                src={displayImage}
                alt="Bagan Struktur Organisasi"
                className="max-h-[calc(100vh-270px)] min-h-[350px] w-auto max-w-full object-contain drop-shadow-2xl transition-transform duration-300 hover:scale-[1.01]"
              />
            ) : (
              <div className="py-[40px] text-slate-400 text-lg">
                Bagan Struktur Organisasi Belum Tersedia
              </div>
            )}
          </div>
        </div>

        <BottomNav page={0} totalPage={1} />
      </div>
    </div>
  );
}
